import { createIdentifier } from '@toeverything/infra';

export interface NativePaywallProvider {
  showPaywall(type: 'Pro' | 'Team' | 'Enterprise'): Promise<void>;
}

export const NativePaywallProvider = createIdentifier<NativePaywallProvider>(
  'NativePaywallProvider'
);
